/* unplugin-vue-components disabled */import { render } from "./user-cancelled.vue?vue&type=template&id=1043b1d1&scoped=true"
import script from "./user-cancelled.vue?vue&type=script&lang=js"
export * from "./user-cancelled.vue?vue&type=script&lang=js"

import "./user-cancelled.vue?vue&type=style&index=0&id=1043b1d1&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1043b1d1"],['__file',"src/components/ai-chat/user-cancelled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1043b1d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1043b1d1', __exports__)) {
    api.reload('1043b1d1', __exports__)
  }
  
  module.hot.accept("./user-cancelled.vue?vue&type=template&id=1043b1d1&scoped=true", () => {
    api.rerender('1043b1d1', render)
  })

}


export default __exports__